import { render } from "./ProjectsSearch.vue?vue&type=template&id=a28160d6&scoped=true"
import script from "./ProjectsSearch.vue?vue&type=script&lang=js"
export * from "./ProjectsSearch.vue?vue&type=script&lang=js"

import "./ProjectsSearch.vue?vue&type=style&index=0&id=a28160d6&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3522\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28160d6"]])

export default __exports__